import deffered from 'yaDeferred';
import getRelayEnvironment from '../relayClientEnvironment';
import * as constants from '../authModal/authentication/authFlowConstants';
import asyncAuth from '../authModal/async';
let Auth;

let authModalLoader = {
    _onLoaded: deffered(),

    /**
     * Splits the AuthModal to a separate chunk during build time. Loads the authModal when called.
     * For now there's no way to handle errors. Should be possible when we switch to webpack 2.
     * This is mostly an espace hatch if you need direct access to the authModal instance.
     *
     * @example
     * authModalLoader.load().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    load() {
        asyncAuth().then((mod) => {
            Auth = mod;
            authModalLoader._onLoaded.resolve(mod);
        });
        return authModalLoader._onLoaded;
    },

    /**
     * Usefull when you don't want to load the AuthModal but want to get the instance.
     *
     * @example
     * authModalLoader.getLoadPromise().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    getLoadPromise() {
        return authModalLoader._onLoaded;
    },

    /**
     * Shortcut to AuthModal.show.
     *
     * @example
     * authModalLoader.show(options).then((authResponse) => if (authResponse.err) FAILURE else SUCCESS);
     * authResponse.user will be an object containing user data: user.userId, user.userToken, user.profile {}.
     * authResponse.err will be an object with shape {err: 'closed'}.
     * it will contain the reason for authentication failure. which is most likely because the user closed the modal.
     * @returns {Promise}
     */
    show(options = {}) {
        const environment = options.relayEnvironment || getRelayEnvironment();
        return new Promise((resolve) => {
            this.load().then((AuthModal) => {
                AuthModal.initAuth({environment});
                switch (options.action) {
                    case constants.LOGIN:
                        Auth.launchLogin({...options, resolve});
                        break;
                    case constants.RESET_PASSWORD:
                        Auth.launchResetPassword({...options, resolve});
                        break;
                    case constants.UPDATE_PASSWORD:
                        Auth.launchUpdatePassword({...options, resolve});
                        break;
                    case constants.RESET_INVALID:
                        Auth.launchResetInvalid({...options, resolve});
                        break;
                    default:
                        Auth.launchRegistration({...options, resolve});
                        break;
                }
            });
        }).then((authResult) => {
            const isRegister = authResult.modal === constants.REGISTER;
            authResult = {...authResult, newUser: isRegister};
            return authResult;
        });
    },

    /**
     * Used for testing only.
     */
    _clearAuthModal() {
        Auth = undefined;
        authModalLoader._onLoaded = deffered();
    },

    /**
     * Used for testing only.
     */
    _setAuthModal(m) {
        Auth = m;
    }
};

authModalLoader = Object.assign(authModalLoader, {constants});

export default authModalLoader;



// WEBPACK FOOTER //
// ./src/utils/AuthModalLoader.js